import { useEffect, useState } from "react";
import Lottie from "lottie-react";
import background_1 from "../animations/background_1.json";
import Style from '../styles/ChangeInitialPass.module.css';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { BiShow, BiHide, BiCheckCircle, BiErrorCircle, BiXCircle } from "react-icons/bi";
import InputAdornment from '@mui/material/InputAdornment';
import ModifyInitialPassword from "../services/ModifyInitialPasssword";
import { decrypt, encrypt } from "../helpers/Helpers";
import { useNavigate } from 'react-router-dom';

function ChangeInitialPassword() {

    const [pass, setPass] = useState('');
    const [repeatPass, setRepeatPass] = useState('');
    const [currentPass, setCurrentPass] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [errors, setErrors] = useState({ pass: '', repeatPass: '' });
    const [showPass, setShowPass] = useState(false);
    const [showRepeatPass, setShowRepeatPass] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const storedCurrentPass = decrypt(sessionStorage.getItem('current'), process.env.REACT_APP_KEY);
        if (storedCurrentPass) {
            setCurrentPass(storedCurrentPass);
        }
    }, []);

    useEffect(() => {
        validatePass();
    }, [pass, repeatPass]);

    const validatePass = () => {
        let passErrors = '';
        let repeatPassErrors = '';

        if (pass != '' && repeatPass != '') {
            if (pass !== repeatPass) {
                repeatPassErrors = 'Passwords do not match.';
            }
            if (pass.length < 10) {
                passErrors = 'Must be min 10 characters';
            }
            if (!/[A-Za-z]/.test(pass)) {
                passErrors = 'Must contain min one letter';
            }
            if (!/[0-9]/.test(pass)) {
                passErrors = 'Must contain min one number';
            }
            if (!/[!@#$%^&*(),.?":{}|<>]/.test(pass)) {
                passErrors = 'Must contain min one special char';
            }
            if (currentPass === pass) {
                passErrors = 'Can´t be same as current password';
            }
        }
        setErrors({ pass: passErrors, repeatPass: repeatPassErrors });
    };

    const toggleShowPass = () => {
        setShowPass(!showPass);
    };

    const toggleShowRepeatPass = () => {
        setShowRepeatPass(!showRepeatPass);
    };

    const handleClick = async () => {
        validatePass();
        if (!errors.pass && !errors.repeatPass) {
            setErrorMsg('');
            const crewCode = sessionStorage.getItem('crewCode');
            const timestamp = new Date().toISOString();
            const checkResult = await (await import('../services/CheckPassword')).default({
                crewCode,
                password: pass,
                timestamp
            });
            if (checkResult.success) {
                ModifyInitialPassword({
                    crewCode,
                    password: pass
                }).then(res => {
                    if (res.success) {
                        sessionStorage.clear();
                        navigate('/', { replace: true });
                    } else {
                        setErrorMsg('Error: try again later');
                    }
                });
            } else {
                setErrorMsg(checkResult.response || 'No se pudo validar la contraseña');
            }
        } else {
            console.log('Error:', errors);
        }
    }

    //vOserONRdVGyBfI7Cb9PxR/jE3sNrRVQWFGhZRYh5j4=

    return (
        <div>
            {errorMsg && (
                <div style={{
                    position: 'absolute',
                    bottom: 12,
                    left: 0,
                    width: '100%',
                    zIndex: 9999999999,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    pointerEvents: 'none',
                }}>
                    <div style={{
                        background: 'linear-gradient(90deg, #232526 0%, #414345 100%)',
                        color: '#e0e7ef',
                        borderRadius: 16,
                        boxShadow: '0 4px 24px 0 rgba(30,40,90,0.18)',
                        padding: '6px',
                        fontSize: '1em',
                        fontWeight: 500,
                        display: 'flex',
                        alignItems: 'center',
                        minWidth: 320,
                        maxWidth: 420,
                        width: '100%',
                        position: 'relative',
                        border: '1.5px solid #3b4252',
                        letterSpacing: 0.1,
                        pointerEvents: 'auto',
                        justifyContent: 'center',
                        gap: 8
                    }}>
                       
                        <span style={{ flex: 1, textAlign: 'center' }}>{errorMsg}</span>
                        <button
                            onClick={() => setErrorMsg('')}
                            style={{
                                background: 'none',
                                border: 'none',
                                color: '#e0e7ef',
                                fontSize: 22,
                                marginLeft: 12,
                                cursor: 'pointer',
                                padding: 0,
                                lineHeight: 1,
                                transition: 'color 0.2s',
                                borderRadius: 8,
                                outline: 'none',
                            }}
                            aria-label="Cerrar mensaje de error"
                        >
                            <BiXCircle style={{ color: '#7dd3fc' }} />
                        </button>
                    </div>
                </div>
            )}
            
            <div className={Style.ChangePassContainer}>
                
                <div className={Style.password_rules} style={{
                    background: 'linear-gradient(90deg, #f0f4ff 0%, #eaf6ff 100%)',
                    borderRadius: '12px',
                    padding: '18px 20px',
                    fontSize: '.6em',
                    color: '#234',
                    boxShadow: '0 2px 8px 0 #e0e8ff',
                    border: '1px solid #dbeafe',
                    maxWidth: 420,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                }}>
                    <div style={{ fontWeight: 600, fontSize: '1.08em', marginBottom: 8, color: '#1e293b', letterSpacing: 0.2 }}>
                        Password requirements
                    </div>
                    <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                        <li style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                            <BiCheckCircle style={{ color: '#2563eb', marginRight: 8 }} /> At least <b>10 characters</b>
                        </li>
                        <li style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                            <BiCheckCircle style={{ color: '#2563eb', marginRight: 8 }} /> At least <b>one letter</b> (A-Z or a-z)
                        </li>
                        <li style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                            <BiCheckCircle style={{ color: '#2563eb', marginRight: 8 }} /> At least <b>one number</b> (0-9)
                        </li>
                        <li style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                            <BiCheckCircle style={{ color: '#2563eb', marginRight: 8 }} /> At least <b>one special character</b> <span style={{ fontFamily: 'monospace', fontSize: '0.98em' }}>(!@#$%^&amp;*(),.?":&#123;&#125;|&lt;&gt;)</span>
                        </li>
                        <li style={{ display: 'flex', alignItems: 'center' }}>
                            <BiErrorCircle style={{ color: '#f59e42', marginRight: 8 }} /> Cannot match <b>any of your last 3 passwords</b>
                        </li>
                    </ul>
                </div>
                <div className={Style.form_container}>
                    <h3 className={Style.form_title}>INSERT NEW PASSWORD</h3>

                    <div className={Style.password_container}>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            className={Style.textfield}
                            type={showPass ? "text" : "password"}
                            value={pass}
                            size="small"
                            placeholder="PASSWORD"
                            onChange={(e) => setPass(e.target.value)}
                            error={Boolean(errors.pass) || Boolean(errorMsg)}
                            helperText={errors.pass || errorMsg}
                            autoComplete="new-password"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <button onClick={toggleShowPass} className={Style.show_pass}>{showPass ? <BiHide className={Style.lock_icon} /> : <BiShow className={Style.lock_icon} />}</button>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                    <div className={Style.password_container}>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            className={Style.textfield}
                            type={showRepeatPass ? "text" : "password"}
                            value={repeatPass}
                            size="small"
                            onChange={(e) => setRepeatPass(e.target.value)}
                            error={repeatPass != '' && Boolean(errors.repeatPass)}
                            helperText={errors.repeatPass}
                            placeholder="REPEAT PASSWORD"
                            autoComplete="new-password"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <button onClick={toggleShowRepeatPass} className={Style.show_pass}>{showRepeatPass ? <BiHide className={Style.lock_icon} /> : <BiShow className={Style.lock_icon} />}</button>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleClick}
                        disabled={Boolean(errors.pass) || Boolean(errors.repeatPass)}
                    >
                        Submit
                    </Button>
                </div>
            </div>

            <Lottie
                className={Style.lottie_file}
                autoplay={false}
                loop
                animationData={background_1}
            />
        </div>
    );
}

export default ChangeInitialPassword;
